export default __webpack_public_path__ + "static/HU_Con_112_PCG1024_11-9b67c81edeea670486d1aca6c1390deb.jpg";